// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { MiniCard } from '../../ui/mini-card/mini-card';

export type Category = {
  name: string;
  items: string[];
};

@Component({
  selector: 'app-technologies-we-use',
  standalone: true,
  imports: [CommonModule, MiniCard],
  templateUrl: './technologies-we-use.html',
})
export class TechnologiesWeUse {
  public categories = signal<Category[]>([
    {
      name: 'Web',
      items: ['angular.png', 'dotnet.png', 'svelte.png', 'fastapi.png'],
    },
    {
      name: 'AI/ML',
      items: ['python.png', 'langchain.png', 'pytorch.png', 'n8n.png'],
    },
  ]);
}
